const host = typeof window !== 'undefined' ? window.location.hostname : 'localhost';

export const environment = {
  production: false,
  montoMay2: 200000,
  apiResrURL: `http://${host}:8080`,
  servImgURL: `http://${host}:8089`,
  RSA_PUBLIC_KEY: `-----BEGIN PUBLIC KEY-----
  MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1BKyvdbeg7QQJYzWRn+v
  A+dW1+jBUL24tpYSdgSy5bTkWSSp/4PZgflGa1+ShMnS7pANv8jsqwZbrmp0/kIJ
  8o1zzgvmi1AlGq9x5nFzRUBUOSY/YTbQAHjO4fx5YHEZiJ8NsvSMOU+YjEaohNY+
  4+ciUGR0KRmt84pe1a/i8k8RHS96NyB1lvMo6snMi+GD8gMdbMe0KagV/kigd12s
  0naoH208YfzWj59I9GphX8uDo7TfTmQZWidaibmu57eyZcXmJGRhLcJWpCLWHYf1
  T3ewtS74h76zuTjnQVl4lN5r+B0RuZ9PPefqN95zwyWCpUXlLZt9Dw52e12nMAqn
  HwIDAQAB
  -----END PUBLIC KEY-----
  `,
    traerImagenes: `http://${host}:8089`,
};

// Urls de cada servicio
const usuariosUrl = `${environment.apiResrURL}/sgi-usuarios`;
const adminUrl = `${environment.apiResrURL}/sgi-administracion`;
const productosUrl = `${environment.apiResrURL}/sgi-productos`;
const operacionesUrl = `${environment.apiResrURL}/sgi-operaciones`;
const ordenesUrl = `${environment.apiResrURL}/sgi-ordenes`;
const estadisticasUrl = `${environment.apiResrURL}/sgi-estadisticas`;

// Conjunto de todas las url publicas
export const publicUrls: any[] = [
  `${usuariosUrl}/auth/login`,
  `${usuariosUrl}/verificarMail`,
  `${adminUrl}/consultarMonto`,
  `${adminUrl}/estadoTienda`,
  `${adminUrl}/zonas`,
  `${adminUrl}/productosMasVendidosDelMes`,
  `${estadisticasUrl}/productosMasVendidosDelMes`,
  `${productosUrl}/api/productos`,
  `${productosUrl}/api/productos/filtrar`,
  `${productosUrl}/api/productos/tipos`,
  `${productosUrl}/api/productos/subtipos`,
  `${productosUrl}/api/productos/producto`,
  `${ordenesUrl}/`,
  `${estadisticasUrl}/visita`,
];
